<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div class="operations" style="margin-top: 5px">
          <div class="filters">
            <el-form
              :inline="true"
              label-width="100px"
              label-position="left"
              @submit.native.prevent="filter.pageNum=1;toQuery()"
            >
              <el-form-item :label="$t('SystemMonitor.ModuleName')">
                <el-select v-model="filter.modelName">
                  <el-option
                    v-for="item in searchModel"
                    :key="item.code"
                    :label="item.chineseName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('SystemMonitor.OperationChangeTime')">
                <el-date-picker v-model="filter.opTimeStar" type="date" value-format="yyyy-MM-dd" />
                <span style="margin: 0 10px">{{ $t('SystemMonitor.To') }}</span>
                <el-date-picker v-model="filter.opTimeEnd" type="date" value-format="yyyy-MM-dd" />
              </el-form-item>
              <el-button type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
              <br>
              <el-form-item :label="$t('SystemMonitor.Operator')">
                <cargo-user-select
                  :default-value="filter.op||''"
                  @change="p=>opChangeHandler(p)"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="total>0"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
    </div>
    <div class="viewDialogClass">
      <el-dialog
        :visible.sync="viewDialog.visible"
        :title="$t('CargoMsg.Cargo_QueryScheme')"
        :modal="false"
        :close-on-click-modal="false"
        :show-close="false"
        :lock-scroll="false"
        width="300px"
        top="20vh"
      >
        <el-input :value="viewDialog.content" type="textarea" :rows="10" />
        <div slot="footer">
          <el-button @click="viewDialog.visible=false">{{ $t('SystemMonitor.Close') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import * as searchLogApi from '@/api/systemMonitor/searchLog'
import viewIcon from '@/assets/view_icon.net.png'

import { DocumentManage } from '@/utils/commonUtil'
export default {
  name: 'SearchLog',
  components: { CargoUserSelect },
  data() {
    return {
      viewIcon,
      documentManage: new DocumentManage(),
      searchModel: SystemConstants.SEARCH_MODEL,
      filter: {
        modelName: '',
        opTimeStar: '',
        opTimeEnd: '',
        op: 0,
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      girdParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [] // 去掉每列的菜单
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.SerialNo'),
          field: 'orderNo',
          width: 200
        },
        {
          headerName: this.$t('SystemMonitor.ModuleName'),
          field: 'modelName',
          width: 200,
          cellRenderer: params => {
            return this.modelNameFunction(params.value)
          }
        },
        {
          headerName: this.$t('SystemMonitor.OperationTime'),
          field: 'dateCreated',
          width: 200
        },
        {
          headerName: this.$t('SystemMonitor.Operator'),
          field: 'createdBy',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SystemMonitor.QueryScheme'),
          field: 'content',
          width: 200,
          cellRenderer: params => {
            let val = ''
            if (params.value && params.value.length > 7) {
              val = params.value.substring(0, 7) + '...  '
            }
            const methodPath = this.documentManage.getPath('showViewDialog')
            return `${val}<img src="${this.viewIcon}" onclick="${methodPath}('${params.data.uuid}')" />`
          }
        }
      ],
      rowData: [],
      addDialogVisible: false,
      formDialog: {
        visible: false,
        isEdit: false,
        uuid: ''
      },
      viewDialog: {
        visible: false,
        content: ''
      }
    }
  },
  watch: {},
  beforeMount() {
    const context = this
    this.documentManage.set('showViewDialog', function(uuid) {
      context.showViewDialog(uuid)
    })
  },
  created() {
    this.filter.opTimeStar = this.filter.opTimeEnd = new Date().toLocaleDateString().replaceAll('/', '-')
  },
  methods: {
    onShow() {
      this.toQuery()
    },
    toQuery() {
      const params = {}
      const conditions = {}
      if (this.filter.opTimeStar) {
        conditions.opTimeStar = this.filter.opTimeStar
      }
      if (this.filter.opTimeEnd) {
        conditions.opTimeEnd = this.filter.opTimeEnd
      }
      // 若开始时间大于结束时间，对调值
      if (this.filter.opTimeStar && this.filter.opTimeEnd) {
        const opTimeStar = new Date(this.filter.opTimeStar)
        const opTimeEnd = new Date(this.filter.opTimeEnd)
        if (opTimeStar > opTimeEnd) {
          conditions.opTimeStar = this.filter.opTimeEnd
          conditions.opTimeEnd = this.filter.opTimeStar
        }
      }
      if (this.filter.modelName) {
        conditions.modelName = this.filter.modelName
      }
      if (this.filter.op) {
        conditions.op = this.filter.op
      }
      if (!this.$store.getters.isAdmin) {
        conditions.op = this.$store.getters.userId
      }
      params.conditions = conditions
      params.pageNum = this.filter.pageNum
      params.pageSize = this.filter.pageSize
      const loading = getLoading()
      searchLogApi.searchLogList(params).then(resp => {
        this.rowData = resp.data.list
        this.filter.pageNum = resp.data.pageNum
        this.filter.pageSize = resp.data.pageSize
        this.total = Number(resp.data.total)
      }).finally(() => loading.close())
    },
    modelNameFunction(value) {
      if (value) {
        const c = SystemConstants.SEARCH_MODEL.find(el => el.code === value)
        return c ? c.chineseName : ''
      }
      return ''
    },
    opChangeHandler(params) {
      this.filter.op = params.value
    },
    showViewDialog(uuid) {
      const row = this.rowData.find(row => row.uuid === uuid)
      if (row) {
        this.viewDialog.content = row.content
        this.viewDialog.visible = true
      }
    }
  }
}
</script>

<style lang="scss">
  .viewDialogClass {
    width: 300px;
    height: 300px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0%, -50%);
    .el-dialog{
      display: flex;
      flex-direction: column;
      margin:0 !important;
      position:absolute;
      top:0;
    }
  }
</style>
